import Requests from './Requests';
import { usePageLoadTracking } from '../../../hooks/usePerformanceTracking';

/**
 * Requests page component that renders the main requests interface.
 * 
 * This component serves as the page-level wrapper for the requests feature,
 * handling page load tracking and rendering the core Requests component.
 * 
 * @returns The rendered requests page
 */
export default function RequestsPage() {
  usePageLoadTracking('requests-page');
  
  return <Requests />;
}